<template>
    <div class="">
        <div class="tw-mt-4 tw-flex" v-for="(item, index) in vacationDays" v-if="vacationDays.length > 0">
            <input type="hidden" :name="'vacation_days[' + index + '][id]'" :value="item.id">

            <div>
                <bordered-input>
                    <template #label>
                        <label :for="'vacation_days_amount_' + index">
                            Urlaub
                        </label>
                    </template>
                    <template #input>
                        <input :id="'vacation_days_amount_' + index" :name="'vacation_days[' + index + '][amount]'" type="text" placeholder="Urlaub" v-model="item.amount">
                    </template>
                </bordered-input>
            </div>

            <div class="tw-ml-2">
                <bordered-input>
                    <template #label>
                        <label :for="'vacation_days_valid_from_' + index">
                            Gültig ab
                        </label>
                    </template>
                    <template #input>
                        <input :id="'vacation_days_valid_from_' + index" :name="'vacation_days[' + index + '][valid_from]'" type="date" placeholder="Gültig ab" v-model="item.valid_from">
                    </template>
                </bordered-input>
            </div>

            <button class="cu-btn-default tw-ml-2" type="button" @click="addVacationDays">
                <i class="fa fa-plus"></i>
            </button>

            <button class="cu-btn-default tw-ml-2" type="button" @click="removeVacationDays(index)">
                <i class="fa fa-trash-o"></i>
            </button>
        </div>
        <div class="tw-mt-4" v-if="vacationDays.length === 0">
            <button type="button" class="cu-btn-default" @click="addVacationDays">
                <i class="fa fa-plus"></i>
                Urlaub eintragen
            </button>
        </div>
    </div>
</template>

<script>
    import BorderedInput from "./BorderedInput";
    import moment from "moment";

    export default {
        components: {
            BorderedInput,
        },

        props: {
            initialVacationDays: {
                required: false,
                default: [],
                type: Array,
            }
        },

        data() {
            return {
                vacationDays: [],
            }
        },

        methods: {
            addVacationDays() {
                this.vacationDays.push({
                    id: null,
                    valid_from: '',
                    amount: '',
                });
            },

            removeVacationDays(index) {
                this.vacationDays.splice(index, 1);
            }
        },

        mounted() {
            if (this.initialVacationDays.length > 0) {
                this.initialVacationDays.forEach(item => {
                    this.vacationDays.push({
                        id: item.id,
                        valid_from: moment(item.valid_from).format('YYYY-MM-DD'),
                        amount: item.amount,
                    });
                })
            }
        }
    }
</script>